<template>
  <Modal
    :width="600"
    :visible="previewVisible"
    :title="title"
    cancelText="取消"
    okText="插入文章"
    @cancel="previewVisible = false"
    @ok="onOk"
  >
    <div class="content">
      <Form
        layout="vertical"
        :model="linkData"
        :labelCol="{ span: 3, offset: 1 }"
        v-if="type === 'customlink'"
      >
        <FormItem label="地址">
          <Input v-model:value="linkData.link" placeholder="请输入地址" />
        </FormItem>
        <FormItem label="显示文字">
          <Input v-model:value="linkData.text" placeholder="请输入显示文字" />
        </FormItem>
      </Form>
      <div v-if="type === 'customimage'">
        <a-upload-dragger
          class="upload-dragger"
          name="file"
          :multiple="true"
          accept=".jpg,.png"
          :show-upload-list="false"
          :action="apiUrl + '/common/UploadFile'"
          :before-upload="beforeUpload"
          @change="handleChange"
        >
          <div class="flex-column xy-center" style="height: 100%; padding: 20px 0">
            <img
              mode="aspectFill"
              src="@/assets/images/upload.png"
              style="width: 40px; height: 40px"
            />
            <p style=" margin-top: 12px;font-size: 14px"
              >将文件拖到此处，或 <span style="color: #7472f6">点击上传</span></p
            >
          </div>
        </a-upload-dragger>
        <div class="upload-tip">只能上传jpg/png文件，且不超过20MB</div>
        <div v-if="fileList.length > 0" class="flex-wrap">
          <div
            v-for="(item, index) in fileList"
            :key="index"
            style="position: relative; margin-top: 20px; margin-right: 20px"
          >
            <img
              class="image-fit"
              :src="item.url"
              style="width: 100px; height: 100px; border-radius: 8px"
            />
            <img
              src="@/assets/images/icon_close@2x.png"
              style=" position: absolute; left: 90px;width: 20px; height: 20px; cursor: pointer"
              @click="fileList.splice(index, 1)"
            />
          </div>
        </div>
      </div>
      <div v-if="type === 'customvideo'">
        <a-upload-dragger
          class="upload-dragger"
          name="file"
          :multiple="true"
          accept=".mp4,.mov"
          :show-upload-list="false"
          :action="apiUrl + '/v1/common/UploadFile'"
          :before-upload="beforeUpload1"
          @change="handleChange"
        >
          <div class="flex-column xy-center" style="height: 100%; padding: 20px 0">
            <img
              mode="aspectFill"
              src="@/assets/images/upload.png"
              style="width: 40px; height: 40px"
            />
            <p style=" margin-top: 12px;font-size: 14px"
              >将文件拖到此处，或 <span style="color: #7472f6">点击上传</span></p
            >
          </div>
        </a-upload-dragger>
        <div class="upload-tip">只能上传mp4/mov文件，且不超过100MB</div>
        <div v-if="fileList.length > 0" class="flex-wrap">
          <div
            v-for="(item, index) in fileList"
            :key="index"
            style="position: relative; margin-top: 20px; margin-right: 20px"
          >
            <video class="image-fit" style="width: 12vw; height: 12vw; border-radius: 8px" controls
              ><source :src="item.url" />
            </video>
            <img
              src="@/assets/images/icon_close@2x.png"
              style=" position: absolute; left: 11vw;width: 20px; height: 20px; cursor: pointer"
              @click="fileList.splice(index, 1)"
            />
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="x-end">
        <Button class="button none" @click="previewVisible = false">取消</Button>
        <Button class="button" @click="onOk" v-if="fileList.length > 0 || linkData.link"
          >插入文章</Button
        >
      </div>
    </template>
  </Modal>
</template>

<script>
  import { Modal, Form, FormItem, Input, Upload, Button, message } from 'ant-design-vue';
  import { useGlobSetting } from '@/hooks/setting';
import baseURL from '@/configs/baseUrl';

  const globSetting = useGlobSetting();
  // const apiUrl = baseURL;
  const ossUrl = globSetting.ossUrl;

  export default {
    name: 'AIMenutool',
    components: {
      Modal,
      Form,
      FormItem,
      Input,
      AUploadDragger: Upload.Dragger,
      Button,
    },
    data() {
      return {
        apiUrl: baseURL,
        title: '',
        type: '',
        fileList: [],
        linkData: {
          link: '',
          name: '',
        },
        previewVisible: false,
      };
    },
    methods: {
      onShow(t) {
        this.fileList = [];
        this.type = t;
        this.linkData.link = '';
        this.linkData.name = '';
        this.previewVisible = true;
        this.title = {
          customlink: '插入链接',
          customimage: '插入图片',
          customvideo: '插入视频',
        }[this.type];
      },
      beforeUpload(file) {
        const isType = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isType) {
          message.warning('仅支持上传图片');
        }
        const isLtSize = file.size / 1024 / 1024 < 20;
        if (!isLtSize) {
          message.warning('请勿上传大小超过20MB的文件');
        }
        return isType && isLtSize;
      },
      beforeUpload1(file) {
        console.log(file);
        const isType = file.type === 'video/mp4' || file.type === 'video/mov';
        if (!isType) {
          message.warning('仅支持上传视频');
        }
        const isLtSize = file.size / 1024 / 1024 < 100;
        if (!isLtSize) {
          message.warning('请勿上传大小超过100MB的文件');
        }
        return isType && isLtSize;
      },
      handleChange(info) {
        if (info.file.status === 'done') {
          const name = info.file.name;
          const file_url = info.file.response.result;
          const file_name = name.substring(0, name.lastIndexOf('.'));
          const file_type = name.substring(name.lastIndexOf('.') + 1);
          this.fileList.push({
            name,
            file_name,
            file_type,
            status: 'done',
            url: ossUrl + file_url,
          });
        }
      },
      onOk() {
        if (this.type === 'customlink') {
          if (!this.linkData.link) return message.warning('请输入地址');
          this.$emit(
            'onAiMenutool',
            `<a href="${this.linkData.link}">${this.linkData.name || this.linkData.link}</a>`,
            this.type,
          );
        } else if (this.type === 'customimage' || this.type === 'customvideo') {
          this.$emit('onAiMenutool', this.fileList, this.type);
        }
        this.previewVisible = false;
      },
    },
  };
</script>

<style lang="less" scoped>
  .content {
    padding: 20px;
  }

  .upload-tip {
    margin-top: 10px;
    color: #666;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
</style>
